export const serviceKeys = [
  { key: "Windshield", label: "Ön Cam Patlaması/Kırılması" },
  { key: "Glass", label: "Cam Kırılması" },
  { key: "Ambulance", label: "Ambulans Hizmeti" },
  { key: "FireDepartment", label: "İtfaiye Hizmeti" },
  { key: "Locksmith", label: "Çilingir Hizmeti" },
  { key: "Accident", label: "Kaza" },
  { key: "Fault", label: "Arıza" },
  { key: "Tire", label: "Lastik Patlaması" },
  { key: "Fuel", label: "Yakıt Bitmesi" },
  { key: "Landslide", label: "Heyelan" },
  { key: "Headlight", label: "Far Arızası" },
  { key: "Health", label: "Sağlık Sorunları" },
  { key: "Tired", label: "Yorgunluktan Kaynaklı Tek Sürücü Araçlar" },
  { key: "EVFault", label: "Elektrikli Araçların Yolda Kalması" },
  {
    key: "WildAnimal",
    label: "Yabani Hayvanların Aracı Haraket Edemez Hale Getirmesi",
  },
];
